const STORAGE_KEY = "manualCorrectionEnabled";

/** Trading currency type, matching the client CurrencyType.TRADING value. */
const TRADING_CURRENCY_TYPE = 3;

export const persistManualCorrectionFlag = (payload) => {
  if (
    !payload ||
    typeof payload !== "object" ||
    !Object.prototype.hasOwnProperty.call(payload, "MANUAL_CORRECTION_ENABLED")
  ) {
    return null;
  }

  const raw = payload.MANUAL_CORRECTION_ENABLED;
  const enabled = raw === true || raw === 1 || raw === "1";
  try {
    sessionStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
  } catch (_) {}
  return enabled;
};

export const readManualCorrectionFlag = () => {
  try {
    return sessionStorage.getItem(STORAGE_KEY) === "1";
  } catch (_) {
    return false;
  }
};

export const clearManualCorrectionFlag = () => {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (_) {}
};

export const readNumericBalance = (source) => {
  if (!source || typeof source !== "object") return 0;
  const raw =
    source.CURRENT_BALENCE ??
    source.CURRENT_BALANCE ??
    source.BALANCE ??
    source.AMOUNT ??
    source.balance ??
    0;
  const numeric =
    typeof raw === "string" ? parseFloat(String(raw).replace(/,/g, "")) : Number(raw);
  return Number.isFinite(numeric) ? numeric : 0;
};

export const isTradingWallet = (source) => {
  if (!source || typeof source !== "object") return false;
  const type =
    source.currencies?.TYPE ??
    source.currency?.TYPE ??
    source.currency?.type ??
    source.CURRENCY_TYPE ??
    source.currencyType;
  if (type !== undefined && type !== null && type !== "") {
    return Number(type) === TRADING_CURRENCY_TYPE;
  }
  const tradingId =
    source.account?.account_information?.TRADING_ID ||
    source.account?.accountInformation?.tradingId ||
    source.TRADING_ID ||
    source.trading_id;
  return Boolean(tradingId);
};

/** Selected dropdown option whose MT5 balance is below 0. */
export const isSelectedMt5BalanceNegative = (option) => {
  const data = option?.data || option;
  if (!data || !isTradingWallet(data)) return false;
  return readNumericBalance(data) < 0;
};
